import { useEffect, useRef } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import Logo from "../../images/logo.svg";
import React, { Fragment } from "react";
import "./PaymentPage.css";
import { t } from "i18next";
const PaymentSTCPayPage = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderid");
  // Moyasar requires an integer amount in halalas; 88.55 * 100 gives
  // 8854.999999999999 in floating point, which the API rejects.
  const amount = Math.round(Number(searchParams.get("amount")) * 100);
  const navigate = useNavigate();
  const paymentRef = useRef(null);

  // callback_url must point at the domain the customer is actually on;
  // a build-time env value once leaked http://localhost:3036 into the
  // production bundle and sent customers there after payment.
  const BASE_URL = window.location.origin;

  useEffect(() => {
    if (window.Moyasar && paymentRef.current) {
      window.Moyasar.init({
        element: paymentRef.current,
        amount: amount,
        currency: "SAR",
        description: "Order Payment",
        publishable_api_key: process.env.REACT_APP_MOYASAR_PUBLISHABLE_KEY,
        callback_url: `${BASE_URL}/order_received?orderid=${orderId}&amount=${amount}`,
        methods: ["stcpay"],
        on_completed: async (payment) => {
          // Best-effort notify; a failure here must never abort Moyasar's
          // own redirect to callback_url.
          try {
            await fetch(`${BASE_URL}/order_received`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                payment_id: payment.id,
                order_id: orderId,
                status: payment.status,
              }),
            });
          } catch (err) {
            console.error("[STCPayPage] on_completed notify failed:", err);
          }

          // Redirect after payment
          navigate(
            `/order_received?orderid=${orderId}&status=${payment.status}`
          );
        },
      });
    }
  }, [orderId, amount, navigate, BASE_URL]);

  return (
    <Fragment>
      <div className="logo-container">
        <Link to="/home">
          <img src={Logo} alt="logo" className="app-logo" />
        </Link>
      </div>
      <div className="payment-container">
        <div className="payment-header">
          <h2>{t("paymentDetails")}</h2>
          <p>
            {t("totalAmount")}: {amount / 100} {t("currency")}
          </p>
        </div>
        <div ref={paymentRef} className="mysr-form"></div>
      </div>
    </Fragment>
  );
};

export default PaymentSTCPayPage;
